const styles = {
  titleHeader: {
    textAlign: "left",
    marginLeft: 4,
  },
  subtitleHeader: {
    textAlign: "left",
    marginLeft: 4,
  },
  labelSx: {
    fontSize: 12,
  },
};

export default styles;
